import { Link } from 'react-router-dom'

/**
 * Hurtigknappen øverst på forsiden (beslutning 082).
 *
 * <p>
 * Den står <b>over</b> dagens opgaver, fordi den er en handling og ikke en
 * oversigt: den, der åbner appen midt på dagen, gør det som regel for at få
 * noget ud af hovedet - ikke for at læse, hvad han allerede er i gang med.
 * </p>
 *
 * <p>
 * Stor og med god plads omkring, for den bliver trykket på med arbejdshandsker
 * og en telefon i den ene hånd.
 * </p>
 */
export function QuickNoteButton() {
  return (
    <Link
      to="/quick-note"
      className="btn btn--primary"
      style={{
        width: '100%',
        padding: '16px 18px',
        fontSize: 16,
        gap: 10,
        textDecoration: 'none'
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 20 }}>
        📝
      </span>
      Hurtig note fra marken
    </Link>
  )
}
